import { Group, SegmentedControl } from '@mantine/core';
import { IconMessageCircle, IconPlus, IconSparkles } from '@tabler/icons-react';
import classes from './ChatModeTabs.module.css';

export type ChatBarTab = 'action' | 'chat' | 'history';

const TABS = [
  { value: 'action' as const, label: 'Steering', Icon: IconSparkles },
  { value: 'chat' as const, label: 'New chat', Icon: IconPlus },
  { value: 'history' as const, label: 'Chats', Icon: IconMessageCircle },
];

type Props = {
  value: ChatBarTab;
  onChange: (value: ChatBarTab) => void;
};

export function ChatModeTabs({ value, onChange }: Props) {
  return (
    <SegmentedControl
      fullWidth
      value={value}
      onChange={next => onChange(next as ChatBarTab)}
      color="brand"
      withItemsBorders={false}
      classNames={{ label: classes.label }}
      styles={{
        root: { padding: 3, borderRadius: 20, backgroundColor: 'rgba(0, 0, 0, 0.2)' },
        indicator: { borderRadius: 16 },
        label: { borderRadius: 16, paddingTop: 10, paddingBottom: 10 },
      }}
      data={TABS.map(({ value: tabValue, label, Icon }) => ({
        value: tabValue,
        label: (
          <Group gap={6} justify="center" wrap="nowrap">
            <Icon size={16} />
            <span>{label}</span>
          </Group>
        ),
      }))}
    />
  );
}
